export type SupportWriteScope = 'resourceAccess.write' | 'userSettings.write' | 'trading.closePosition.write';

export const SUPPORT_WRITE_SCOPE_OPTIONS: {
    value: SupportWriteScope;
    label: string;
    description: string;
}[] = [
    {
        value: 'resourceAccess.write',
        label: 'Resource sharing',
        description: 'Allow sharing, revoking, and publishing the customer’s reusable resources.'
    },
    {
        value: 'userSettings.write',
        label: 'User settings',
        description: 'Allow saving user-level preferences and settings.'
    },
    {
        value: 'trading.closePosition.write',
        label: 'Close positions',
        description: 'Allow full close-only trades for existing open positions. Requires passkey approval.'
    }
];

const SUPPORT_WRITE_SCOPE_LABELS: Record<SupportWriteScope, string> = SUPPORT_WRITE_SCOPE_OPTIONS.reduce(
    (accumulator, option) => ({
        ...accumulator,
        [option.value]: option.label
    }),
    {} as Record<SupportWriteScope, string>
);

export function getSupportWriteScopeLabel(scope: SupportWriteScope): string {
    return SUPPORT_WRITE_SCOPE_LABELS[scope] ?? scope;
}
